<template>
  <header class="page-product-family-header">
    <!-- Content -->
    <div class="page-product-family-header__content p-top-5 p-bot-3">
      <div class="row-1 page-product-family-header__content__wrap">
        <NavigationBackLink
          data-animate="header-content"
          class="row-1"
          :light="true"
          :link="{
            title: $t('pages.product.backLinkCollection'),
            route: {
              name: 'typology-collections',
            },
          }"
        />
        <!-- Title -->
        <div
          class="page-product-family-header__content__title m-top-5 m-bot-4"
          :class="{
            '--small-title-on-mobile':
              props.family.smallTitleOnMobile.includes('si'),
          }"
        >
          <template v-if="props.family.productFamilyDescription">
            <div
              class="text-l m-bot-4 page-product-family-header__content__text --large"
              data-animate="header-content"
              v-html="props.family.productFamilyDescription"
            ></div
          ></template>

          <h1 data-animate="header-title" class="title-xl">
            {{ props.family.title }}
          </h1>
        </div>
        <!-- Categories -->
        <div
          class="page-product-family-header__content__categories"
          data-animate="header-content"
        >
          <ul>
            <li
              v-for="category in categories"
              :key="category.id"
              class="text-m"
            >
              <NuxtLink
                :to="
                  localePath({
                    name: 'category-slug',
                    params: {
                      slug: category.slug,
                    },
                  })
                "
                class="link-underline-reverse-1"
              >
                {{ category.title }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Picture -->
    <div class="page-product-family-header__image" data-animate="header-image">
      <WidgetPicture
        :image="{
          custom: props.family.productFamilyCover?.[0],
        }"
        v-anim-parallax-element="{
          target: 'picture',
        }"
        :alt="props.family.productFamilyCover?.[0]?.title"
      />
    </div>
  </header>

  <!-- Description mobile fallback -->
  <template v-if="props.family.productFamilyDescription">
    <div
      class="row-1 text-l p-top-3 page-product-family-header__content__text --small"
      data-animate="header-content"
      aria-hidden="true"
      v-html="props.family.productFamilyDescription"
    ></div
  ></template>
</template>

<script>
export default {
  name: 'PagesProductFamilyHeader',
}
</script>

<script setup>
const props = defineProps({
  family: Object,
})

const categories = computed(() => {
  const categoriesSet = new Set(
    props.family.children
      .flatMap((child) => child.relatedCategories || [])
      .map((category) => JSON.stringify(category))
  )
  return [...categoriesSet].map((item) => JSON.parse(item))
})
</script>

<style lang="scss">
@import './style.scss';
</style>
